import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vant from 'vant'
import 'vant/lib/index.css'

// 加载全局样式，一定要放在其他插件的样式之后
import "@/assets/index.scss"

import { Toast } from 'vant';
import Meta from "vue-meta";
import { Notify } from 'vant';

// 全局注册
Vue.use(Notify);
Vue.use(Meta);
Vue.use(Toast);

Vue.use(Vant)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
